var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10 3L4.5 8.5 2 6","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }